import Button from './Button';
import { useNavigate } from 'react-router-dom';
import { sections } from '../constants/menuItems';

function App() {
  const navigate = useNavigate();

  return (
    <main className="px-8 py-12 max-w-6xl mx-auto">
      <section className="mb-16">
        <h2 className="text-xl font-semibold mb-6">Allgemein</h2>

        <div className="flex justify-center items-center h-24 p-3 rounded-2xl border border-white/20 bg-gradient-to-b from-[#3c60ed] to-[#1633a9]">
          <a href="https://app.langdock.com/" target="_blank" rel="noopener noreferrer" className="h-full w-full flex items-center justify-center">
            <img src="/images/langdock.png" className="max-h-full max-w-full object-contain"/>
          </a>
        </div>
      </section>

      {Object.entries(sections).map(([section, sectionCategories]) => (
        <section className="mb-16">
          <h2 className="text-xl font-semibold mb-6">{section}</h2>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4">
            {Object.entries(sectionCategories).map(([index, category]) => (
              <Button key={index} label={category.label} link={category.link} color={category.color} icon={category.icon}/>
            ))}
          </div>
        </section>
      ))}

      {/* Neuer Button am Ende */}
      <div className="mt-12 text-center">
        <button
          onClick={() => navigate('/submit')}
          className="bg-blue-500 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-600 transition-colors"
        >
          + Weiteres Tool hinzufügen
        </button>
      </div>
    </main>
  );
}

export default App;
